<template>
  <div class="main-container">
    <div class="music-tabs">
      <button
        @click="animate('buckethead')"
        :disabled="currentMusic === 'buckethead'"
        class="music-btn"
      >
        Rock
      </button>
      <button
        @click="animate('matteis')"
        :disabled="currentMusic === 'matteis'"
        class="music-btn"
      >
        Baroque
      </button>
      <button
        @click="animate('cbl')"
        :disabled="currentMusic === 'cbl'"
        class="music-btn"
      >
        Ambient
      </button>
    </div>
    <div class=" musics">
      <music-cover
        :image="musics.cbl.image"
        :amplitude="musicAmplitude"
        :artist="currentAlbum"
        class="cover-container"
      ></music-cover>

      <div class="music">
        <div style="display: flex; align-items: center">
          <div>
            <a :href="spotifyUrl" target="_blank"
              ><img
                src="../assets/spotify.svg"
                height="30"
                alt="spotify"
                style="width: auto"
            /></a>
          </div>
          <div class="music-title" style="width: 100%; margin-left: 10px;">
            <h3 class="title-cbl">
              {{ musics.cbl.title }}
            </h3>
            <h3 class="title-buckethead">
              {{ musics.buckethead.title }}
            </h3>
            <h3 class="title-matteis">
              {{ musics.matteis.title }}
            </h3>
          </div>
        </div>

        <p>by {{ musics[currentMusic].by }}</p>
        <div class="player">
          <div class="play" @click="playSong">
            <img v-if="!playing" src="../assets/play.svg" height="20" alt="" />
            <img v-if="playing" src="../assets/pause.svg" height="20" alt="" />
          </div>
          <div id="waveform"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import interloper from "@/assets/interloper.jpg";
import supersede from "@/assets/cbl-supersede.mp3";
import sunbursts from "@/assets/sunbursts.mp3";
import baroque from "@/assets/baroque.mp3";
// import { ParallaxElement, ParallaxContainer } from "vue-mouse-parallax";
import MusicCover from "./MusicCover.vue";
import anime from "animejs";
export default {
  components: {
    // ParallaxElement,
    // ParallaxContainer,
    MusicCover
  },
  data() {
    return {
      playing: false,
      currentMusic: "matteis",
      currentAlbum: "matteis",
      musics: {
        cbl: {
          image: interloper,
          title: "Supersede",
          spotify:
            "https://open.spotify.com/track/7MZLPKriK0CMy6a0ovE1Ca?si=mFmWtw7TSfW_o0ojYLckbw",
          by: "Carbon Based Lifeforms",
          description: "lorem",
          music: supersede
        },
        buckethead: {
          image: interloper,
          title: "Sunbursts",
          spotify:
            "https://open.spotify.com/track/0GoLz7nr4JWT2PdvzwZPxv?si=9djQTDNRS4yqDLdOS5x0xQ",
          by: "Buckethead",
          description: "lorem",
          music: sunbursts
        },
        matteis: {
          image: interloper,
          title: "Diverse Bizzarie",
          spotify:
            "https://open.spotify.com/track/3OIBsmWJx3xOevzq5jmjfi?si=rXPttUGFTmKMpRV6u3FgvQ",
          by: "Nicolas Matteis, Gli Incogniti",
          description: "lorem",
          music: baroque
        }
      },
      analyser: null,
      dataArray: null,
      amplitude: 1,
      wavesurfer: null
    };
  },
  mounted() {
    var wavesurfer = WaveSurfer.create({
      container: "#waveform",
      waveColor: "#EDD88C",
      barGap: 3,
      barRadius: 3,
      barWidth: 3,
      progressColor: "#D8F235",
      cursorColor: "#EDD88C",
      hideScrollbar: true,
      responsive: true
    });

    wavesurfer.load(this.musics[this.currentMusic].music);

    var analyser = wavesurfer.backend.analyser;
    analyser.fftSize = 256;
    var bufferLength = analyser.frequencyBinCount;
    var dataArray = new Uint8Array(bufferLength);
    this.dataArray = dataArray;
    this.analyser = analyser;
    this.wavesurfer = wavesurfer;

    wavesurfer.on("finish", () => {
      this.playing = false;
    });
  },
  computed: {
    musicAmplitude() {
      return this.amplitude;
    },
    spotifyUrl() {
      return this.musics[this.currentMusic].spotify;
    }
  },
  methods: {
    playSong() {
      this.playing = !this.playing;
      this.wavesurfer.playPause();
      if (this.playing) {
        this.getSongData();
      }
    },
    getSongData() {
      if (this.playing) {
        this.analyser.getByteFrequencyData(this.dataArray);

        //   let datata = this.dataArray[24] > 1 ? this.dataArray[50] : 1;
        // let datata = this.dataArray[80] > 1 ? this.dataArray[80] : 1;
        let datata = [
          this.dataArray[10] > 1 ? this.dataArray[10] : 1,
          this.dataArray[30] > 1 ? this.dataArray[30] : 1,
          this.dataArray[50] > 1 ? this.dataArray[50] : 1,
          this.dataArray[70] > 1 ? this.dataArray[70] : 1
        ];

        this.amplitude = datata;
        requestAnimationFrame(this.getSongData);
      }
    },
    animate(artist) {
      const _this = this;
      this.wavesurfer.on("ready", function() {
        anime({
          targets: "#waveform",
          opacity: [0, 1],
          easing: "easeOutQuint",
          duration: 1000
        });
      });
      anime({
        targets: "#waveform",
        opacity: 0,
        easing: "easeInQuint",
        duration: 300,
        complete: function() {
          _this.wavesurfer.load(_this.musics[artist].music);
          _this.playing = false;
        }
      });
      // anime({
      //   targets: ".cover-container",
      //   translateY: -90,
      //   opacity: 0,
      //   easing: "easeInElastic(5, 1)",
      //   duration: 500
      // });

      this.animateTitle(artist);
    },
    animateTitle(artist) {
      const _this = this;
      this.currentAlbum = artist;
      anime({
        targets: `.title-${this.currentMusic}`,
        translateY: -40,
        opacity: 0,
        easing: "easeInQuint",
        duration: 400,
        complete: () => {
          _this.currentMusic = artist;
        }
      });
      anime({
        begin: function() {
          document.querySelector(`.title-${artist}`).style.display = "block";
        },
        targets: `.title-${artist}`,
        translateY: [40, 0],
        opacity: [0, 1],
        easing: "easeOutQuint",
        delay: 200,
        duration: 400
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .musics {
    flex-direction: column;
    height: auto !important;
  }
}

.musics {
  display: flex;
  height: 60vh;
  color: white;

  > div:nth-of-type(1) {
    width: 40%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media only screen and (max-width: 768px) {
    > div:nth-of-type(1) {
      width: 100%;
      margin-top: 15px;
      height: auto;
    }
  }
  > div:nth-of-type(2) {
    width: 60%;
    padding-left: 25px;
  }
  @media only screen and (max-width: 768px) {
    > div:nth-of-type(2) {
      width: 100%;
      padding-left: 0px;
    }
  }

  img {
    width: 70%;
    border-radius: 10px;
    position: relative;
  }

  h3 {
    font-size: 40px;
    align-self: flex-start;
  }
}

.cover {
  position: relative;
}

.cover-container {
  text-align: center;
}

.music {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.music-btn {
  background-color: transparent;
  border: none;
  color: white;
  font-weight: 700;
  margin-left: 15px;
  font-family: "Questrial", sans-serif;
  padding-bottom: 5px;
  padding-top: 5px;
  transition: box-shadow 300ms;
  cursor: pointer;
}

.music-btn:disabled,
.music-btn:hover {
  box-shadow: 0px 5px 0px 0px rgba(216, 242, 53, 1);
}

.music-tabs {
  text-align: center;
}

.smooth {
  transition: transform 100ms;
}

.play {
  background-color: #edd88c;
  width: 60px;
  height: 60px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

#waveform {
  width: 80%;
  overflow: hidden;
}

.player {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.music-title {
  overflow: hidden;
  height: 40px;
  position: relative;
}

.title-cbl {
  display: none;
  position: absolute;
}

.title-buckethead {
  position: absolute;
  display: none;
}
.title-matteis {
  position: absolute;
}

.circle {
  border-radius: 100%;
  position: absolute;

  &.yellowgreenposition {
    top: 40px;
    left: 15px;
  }

  .yellowgreencolor {
    background-color: $color-yellowgreen;
    width: 90px;
    height: 90px;
    border-radius: 100%;
  }

  &.darkgreenposition {
    top: 55px;
    left: 20px;
  }

  .darkgreencolor {
    background-color: $color-darkgreen;
    width: 170px;
    height: 170px;
    border-radius: 100%;
  }

  &.brightgreenposition {
    bottom: 50px;
    right: 20px;
  }

  .brightgreencolor {
    border: $color-brightgreen 4px solid;
    border-radius: 100%;
    width: 80px;
    height: 80px;
  }
}
</style>
